import React from 'react';
import { Box } from '@mui/material';
import ProfileScoreCategoryCard from './ProfileScoreCategoryCard';
import { ProfileScoreCategory } from '../../../../interfaces/gamification.interface';
import { defaultProfileScoreCategoriesData } from './defaultProfileScoreCategoriesData';
import { mergeProfileScoreCategories } from './profileScoreCategoriesUtils';

interface IProfileScoreList {
  profileScoreCategory: ProfileScoreCategory[];
}

const ProfileScoreCategoryList = ({
  profileScoreCategory,
}: IProfileScoreList) => {
  return (
    <Box sx={scrollingResponsiveStyles}>
      <Box
        component={'ul'}
        sx={{
          display: 'flex',
          flexDirection: { xs: 'row', lg: 'column' },
          gap: '1.375rem',
          padding: {
            xs: '1rem',
            lg: '1.375rem 1rem',
          },
          margin: 0,
          width: { xs: 'max-content', lg: '100%' },
        }}
      >
        {mergeProfileScoreCategories(
          profileScoreCategory,
          defaultProfileScoreCategoriesData
        ).map(category => (
          <Box
            component={'li'}
            key={category.id}
            sx={{
              maxWidth: { xs: 'calc(100vw - 4rem)', lg: '100%' },
              flexShrink: 0,
            }}
          >
            <ProfileScoreCategoryCard category={category} />
          </Box>
        ))}
      </Box>
    </Box>
  );
};

const scrollingResponsiveStyles = {
  width: '100%',
  overflowX: 'auto',
  WebkitOverflowScrolling: 'touch',

  // WebKit browsers (Chrome, Safari)
  '&::-webkit-scrollbar': {
    height: '8px',
    display: { xs: 'none', md: 'block', lg: 'none' },
  },
  '&::-webkit-scrollbar-track': {
    backgroundColor: 'rgba(0,0,0,0.05)',
  },
  '&::-webkit-scrollbar-thumb': {
    backgroundColor: 'rgba(0,0,0,0.2)',
    borderRadius: '4px',
    '&:hover': {
      backgroundColor: 'rgba(0,0,0,0.3)',
    },
  },

  // Firefox
  scrollbarWidth: { xs: 'none', md: 'thin', lg: 'none' },
  scrollbarColor: 'rgba(0,0,0,0.2) rgba(0,0,0,0.05)',

  // IE/Edge
  msOverflowStyle: { xs: 'none', md: 'auto', lg: 'none' },

  // Smooth scrolling for all methods
  scrollBehavior: 'smooth',
};

export default ProfileScoreCategoryList;
